module.exports = __webpack_public_path__ + "img/battery-full.3e0f382c.svg";